import React, { useState } from "react";
import { formatMeters } from "../Graficos/PrevisaoDeDemanda/formatters";

const TabelaPrevisao = ({ series, futureLabels, methods = [] }) => {
  const [visaoAtiva, setVisaoAtiva] = useState("real");
  
  const [expandida, setExpandida] = useState(false);

  const labels = [...series.map((item) => item.label), ...futureLabels];

  const botoes = [
    { id: "real", label: "Real" },
    ...methods.filter(Boolean).map((m) => ({ id: m.key, label: m.method.label })),
  ];
  
  if (methods.length > 0) {
    botoes.push({ id: "comparativo", label: "Comparativo" });
  }

  let colunasAtivas = [];
  
  if (visaoAtiva === "comparativo") {
    colunasAtivas = [
      { id: "real", label: "Real" },
      ...methods.filter(Boolean).map((m) => ({ id: m.key, label: m.method.label }))
    ];
  } else if (visaoAtiva === "real") {
    colunasAtivas = [{ id: "real", label: "Real" }];
  } else {
    const metodoSelecionado = methods.find((m) => m.key === visaoAtiva);
    if (metodoSelecionado) {
      colunasAtivas = [{ id: metodoSelecionado.key, label: metodoSelecionado.method.label }];
    }
  }

  const getValorDaCelula = (colunaId, index) => {
    if (colunaId === "real") {
      return index < series.length ? series[index].value : null;
    }
    
    const metodo = methods.find((m) => m.key === colunaId);
    if (metodo) {
      const dadosDoMetodo = [...metodo.method.fitted, ...metodo.method.future];
      return dadosDoMetodo[index];
    }
    
    return null;
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      
      <button
        onClick={() => setExpandida(!expandida)}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "#2563eb",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "1rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: 0,
          marginBottom: expandida ? "1.5rem" : "0" 
        }}
      >
        <span>{expandida ? "▼" : "▶"}</span>
        {expandida ? "Ocultar tabela de dados" : "Ver tabela de dados"}
      </button>

      {expandida && (
        <div style={{ overflowX: "auto" }}>
          
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginBottom: "1rem" }}>
            {botoes.map((botao) => (
              <button
                key={botao.id}
                onClick={() => setVisaoAtiva(botao.id)}
                style={{
                  padding: "0.5rem 1rem",
                  cursor: "pointer",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor: visaoAtiva === botao.id ? "#2563eb" : "#f3f4f6",
                  color: visaoAtiva === botao.id ? "#ffffff" : "#000000",
                  fontWeight: visaoAtiva === botao.id ? "bold" : "normal",
                }}
              >
                {botao.label}
              </button>
            ))}
          </div>

          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", minWidth: "600px" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid #e5e7eb" }}>
                <th style={{ padding: "0.75rem", backgroundColor: "#f9fafb" }}>Período</th>
                {colunasAtivas.map((coluna) => (
                  <th key={coluna.id} style={{ padding: "0.75rem", backgroundColor: "#f9fafb" }}>
                    {coluna.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {labels.map((label, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #f3f4f6" }}>
                  <td style={{ padding: "0.75rem", fontWeight: "500" }}>{label}</td>
                  {colunasAtivas.map((coluna) => {
                    const valor = getValorDaCelula(coluna.id, index);
                    return (
                      <td key={coluna.id} style={{ padding: "0.75rem" }}>
                        {valor !== null && valor !== undefined ? formatMeters(valor) : "—"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
      )}
      
    </div>
  );
};

export default TabelaPrevisao;